import $ from 'jquery';

const defaults = {
  date: undefined,
  month: undefined,
  day: undefined,
  year: undefined,
  endMonth: undefined,
  endDay: undefined,
  endYear: undefined,
  isRange: false,
};

export default class FixDates {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = { ...defaults, ...options };
    this.fixDate();

    // Ready Component
    this.ready();
  }

  fixDate() {
    const hasPostDate = this.$element.find('.post-date').length > 0;
    const isEvent = this.$element.find('.post-date').is('.upcoming');
    const isTwitterFeed = this.$element.find('.handle + .date').length > 0;
    if (hasPostDate && !isEvent) {
      const dateContent = this.element.querySelector('.post-date time').childNodes[0].nodeValue;
      this.extractDate(dateContent);
      this.$element.find('.post-date time').html(`<span class="date-time-rendered">${this.settings.month} ${this.settings.day}</span>`);
      this.$element.find('.post-date').show();
    } else if (isTwitterFeed) {
      const tweetContent = this.element.querySelector('.handle + .date time').childNodes[0].nodeValue;
      this.extractDate(tweetContent);
      this.$element.find('.handle + .date').html(`${this.settings.month} ${this.settings.day}`);
    } else {
      const hasEventDate = this.element.querySelector('.upcoming.first-upcoming time > span[class^="date-display-"]').childNodes[0].nodeValue;
      if (hasEventDate) {
        const isRange = this.$element.find('.date-display-start').length > 0;
        if (isRange) {
          const startDate = this.element.querySelector('.date-display-start').childNodes[0].nodeValue;
          const endDate = this.element.querySelector('.date-display-end').childNodes[0].nodeValue;
          this.extractDate(startDate);
          this.settings.isRange = true;
          this.extractEndDate(endDate);
          if (this.settings.year !== this.settings.endYear) {
            this.$element.find('.post-date time').html(`<span class="date-time-rendered">${this.settings.month} ${this.settings.day}, ${this.settings.year} - ${this.settings.endMonth} ${this.settings.endDay}, ${this.settings.endYear}</span>`);
          } else if (this.settings.month !== this.settings.endMonth) {
            this.$element.find('.post-date time').html(`<span class="date-time-rendered">${this.settings.month} ${this.settings.day} - ${this.settings.endMonth} ${this.settings.endDay}</span>`);
          } else {
            this.$element.find('.post-date time').html(`<span class="date-time-rendered">${this.settings.month} ${this.settings.day} - ${this.settings.endDay}</span>`);
          }
        } else {
          const eventContent = this.element.querySelector('.upcoming.first-upcoming time > span[class^="date-display-"]').childNodes[0].nodeValue;
          this.extractDate(eventContent);
          this.$element.find('.post-date time').html(`<span class="date-time-rendered">${this.settings.month} ${this.settings.day}</span>`);
        }
      }
    }
  }

  extractDate(dateText) {
    const newDateArr = dateText.split(' ');
    const newMonth = newDateArr[0];
    this.abbrevMonth(newMonth);
    this.settings.day = newDateArr[1].substring(0, newDateArr[1].length - 1);
    this.settings.year = newDateArr[2].substring(0, newDateArr[2].length);
  }

  extractEndDate(dateText) {
    const newDateArr = dateText.split(' ');
    const newMonth = newDateArr[0];
    this.abbrevMonth(newMonth, true);
    this.settings.endDay = newDateArr[1].substring(0, newDateArr[1].length - 1);
    this.settings.endYear = newDateArr[2].substring(0, newDateArr[2].length);
  }

  abbrevMonth(month) {
    let newMonth;
    switch (month) {
      case 'January': newMonth = 'jan'; break;
      case 'February': newMonth = 'feb'; break;
      case 'March': newMonth = 'mar'; break;
      case 'April': newMonth = 'apr'; break;
      case 'May': newMonth = 'may'; break;
      case 'June': newMonth = 'jun'; break;
      case 'July': newMonth = 'jul'; break;
      case 'August': newMonth = 'aug'; break;
      case 'September': newMonth = 'sep'; break;
      case 'October': newMonth = 'oct'; break;
      case 'November': newMonth = 'nov'; break;
      case 'December': newMonth = 'dec'; break;
      default: newMonth = 'N/A';
    }
    if (this.settings.isRange) {
      this.settings.endMonth = newMonth;
    } else {
      this.settings.month = newMonth;
    }
  }

  ready() {
    this.element.classList.add('ready');
  }
}
